export default __webpack_public_path__ + "static/media/Girdle of the Kozak Slayer.e7e7bbe6.jpg";